module.exports = __webpack_public_path__ + "static/media/fire.8537d5f4.svg";